/* Rangreza: per-colour pose gallery. Active only on products tagged gallery-by-colour.
   Keeps the viewed pose when the shopper changes colour or size. */
(function () {
  if (window.rzColourGallery) return;
  window.rzColourGallery = true;

  var mql = window.matchMedia('(min-width: 750px)');

  function altOf(li) {
    var img = li && li.querySelector('img');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function poseOf(alt) {
    var i = alt.lastIndexOf(', ');
    return i === -1 ? '' : alt.slice(i + 2);
  }

  function slidesOf(gallery) {
    var list = gallery.querySelector('[id^="Slider-Gallery"]');
    return list ? Array.prototype.slice.call(list.querySelectorAll('li[data-media-id]')) : [];
  }

  function currentSlide(gallery) {
    var slides = slidesOf(gallery);
    if (!slides.length) return null;
    if (mql.matches) return gallery.querySelector('[id^="Slider-Gallery"] li.is-active') || slides[0];
    var list = slides[0].parentElement;
    var x = list.scrollLeft;
    var best = slides[0];
    var bestDistance = Infinity;
    slides.forEach(function (li) {
      var distance = Math.abs(li.offsetLeft - x);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = li;
      }
    });
    return best;
  }

  function galleryFor(node) {
    var info = node && node.closest ? node.closest('product-info') : null;
    return info ? info.querySelector('media-gallery[data-rz-gallery]') : null;
  }

  function onOptionChange(payload) {
    var data = payload && payload.data;
    var gallery = galleryFor(data && (data.target || (data.event && data.event.target)));
    if (!gallery) return;
    gallery.rzPose = poseOf(altOf(currentSlide(gallery)));
  }

  function onVariantChange(payload) {
    var data = payload && payload.data;
    if (!data || !data.variant) return;
    var gallery = document.getElementById('MediaGallery-' + data.sectionId);
    if (!gallery || !gallery.hasAttribute('data-rz-gallery')) return;

    var index = parseInt(gallery.getAttribute('data-rz-colour-index'), 10);
    var colour = data.variant.options && data.variant.options[index];
    if (colour) {
      gallery.setAttribute('data-rz-colour', colour);
      gallery.querySelectorAll('[id^="Slider-Thumbnails"] li[data-target]').forEach(function (li) {
        li.classList.toggle('rz-thumb-hide', altOf(li).indexOf(colour) === -1);
      });
    }

    var pose = gallery.rzPose;
    gallery.rzPose = null;
    if (!pose || typeof gallery.setActiveMedia !== 'function') return;
    var match = slidesOf(gallery).filter(function (li) {
      var alt = altOf(li);
      return poseOf(alt) === pose && (!colour || alt.indexOf(colour) !== -1);
    })[0];
    if (match && !match.classList.contains('is-active')) {
      gallery.setActiveMedia(match.dataset.mediaId, false);
    } else if (match && !mql.matches) {
      match.parentElement.scrollTo({ left: match.offsetLeft });
    }
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, onOptionChange);
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
